import { map, mergeMap, Observable, of } from 'rxjs';
import { UseCase } from '@domain/base/use-case';
import { CartRepository } from '@domain/models/cart/gateway/cart-repository';
import { Archetype, Lego } from '@domain/models/task/task';
import { Cart } from '@domain/models/cart/cart';

export class AddLegoToCartUseCase implements UseCase<Lego | Archetype, Cart> {
  constructor(private readonly _cartRepository: CartRepository) {}

  execute(task: Lego | Archetype): Observable<Cart> {
    return this._cartRepository.get().pipe(
      map((cart) => {
        if (!cart) {
          return this._cartRepository.create();
        }
        return of();
      }),
      mergeMap(() => this._cartRepository.addTask(task))
    );
  }
}
